import { render, staticRenderFns } from "./myCouse.vue?vue&type=template&id=3983749d"
import script from "./myCouse.vue?vue&type=script&lang=js"
export * from "./myCouse.vue?vue&type=script&lang=js"
import style0 from "./myCouse.vue?vue&type=style&index=0&id=3983749d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports